<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
        <template slot="menuLeft">
            <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('在线咨询', '用户、工号、电话、部门、咨询内容、咨询时间、回复内容')">导出Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
            <el-button icon="el-icon-edit" size="small" type="text" v-if="!scope.row.reply" @click.stop="handleReply(scope.row,scope.index)">回复</el-button>
        </template>
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText:'新增通知', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText: '回复',
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '用户信息',
              overHidden: true,
              prop: 'user-username',
              editDisplay: false,
              span: 24,
            },
            {
              label: '部门',
              overHidden: true,
              prop: 'user-class',
              editDisplay: false,
              span: 24,
            },
            {
              label: '反馈内容',
              overHidden: true,
              prop: 'content',
              type: 'textarea',
              editDisplay: false,
              span: 24,
              align: 'left',
            },
            {
              label: '反馈时间',
              prop: 'created_at',
              display: false
            },
            {
              label: '回复',
              prop: 'reply',
              type: 'textarea',
              span: 24,
              overHidden: true,
            }
          ]
        }
      }
    },
    methods: {
      // 回复
      handleReply (row, index) {
        this.$refs.crud.rowEdit(row, index)
      }
    }
  }
</script>
